import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar, Footer, ContactBar, ScrollToTop } from './components';
import { useTheme } from './context/ThemeContext';
import useAnalytics from './hooks/useAnalytics';

const App = () => {
  const { theme } = useTheme();
  const [isMounted, setIsMounted] = useState(false);

  // Initialize analytics tracking
  useAnalytics();

  // Check if we're on a mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Use data-theme attribute for easier component styling
  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    
    // This ensures the component has fully mounted before rendering child components
    // Helps with mobile rendering issues
    setIsMounted(true);
    
    console.log('App mounted, theme:', theme);
    console.log('Mobile device:', isMobile);
    
    return () => document.body.removeAttribute('data-theme');
  }, [theme]);

  if (!isMounted) {
    // Return a minimal loading state before full render
    // This prevents potential rendering issues on mobile
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: theme === 'dark' ? '#1a202c' : '#ffffff',
        color: theme === 'dark' ? '#ffffff' : '#1a202c'
      }}>
        <p>Loading application...</p>
      </div>
    );
  }

  return (
    <div className={`flex flex-col min-h-screen ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'}`}>
      <ScrollToTop />
      <ContactBar />
      <Navbar />
      <main className={`flex-grow ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default App;
